export * from './erforderliches-dokuments-sorter.component';
export * from './erforderliches-dokuments-sorter.component.module';